import type React from "react";
import { useCallback, useState } from "react";

// Simple decompress replacement
const decompress = (data: any) => data;

const DebuggerGraphExtractor = () => {
  const [result, setResult] = useState("");
  const [copied, setCopied] = useState(false);

  const handleFileUpload = useCallback(async (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setCopied(false);
    let value = e.target.value;
    if ((e.target as any).files) {
      const file: File = (e.target as any).files[0];
      value = await file.text();
      setResult(JSON.stringify(decompress(JSON.parse(value).compressed), null, 2));
    }
  }, []);

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(result);
    setCopied(true);
  }, [result]);

  return (
    <div style={{ width: "100%" }}>
      <b>Extract compressed release:</b>
      <input
        accept=".json,application/JSON"
        onChange={handleFileUpload}
        type={"file"}
      />

      <div>Output:</div>
      <textarea
        style={{ width: "100%" }}
        rows={5}
        value={result}
      ></textarea>
      <br />
      <button
        disabled={!result}
        onClick={handleCopy}
      >
        Copy
      </button>
      {copied ? <small style={{ color: "gray", marginLeft: "5px" }}>Copied!</small> : null}
    </div>
  );
};

export default DebuggerGraphExtractor;
